export default "__VITE_PUBLIC_ASSET__157676a2__"